module.exports = __webpack_public_path__ + "static/img/introduceBTypeBIcon8.002389d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduceBTypeBIcon8.png
// module id = R/um
// module chunks = 0